import apiUrl from '../util/apiURL';

const Version = '2016-03-04';
const Service = 'eip';


export default {
    QueryKECVifListForAssociateEip: apiUrl({
        Action: 'QueryKECVifListForAssociateEip',
        Version,
        Service
    }),
    QueryEPCVifListForAssociateEip: apiUrl({
        Action: 'QueryEPCVifListForAssociateEip',
        Version,
        Service
    }),
    QueryContainerVifListForAssociateEip: apiUrl({
        Action: 'QueryContainerVifListForAssociateEip',
        Version,
        Service
    }),
    //分配项目
    UpdateInstancesProjectId: {
        url: apiUrl({
            Action: 'UpdateInstancesProjectId',
            Service: 'iam',
            Version: '2015-11-01'
        }),
        method: 'post'
    },
    //获取项目制
    getAllotDataNew: apiUrl({
        Action: 'GetAccountAllProjectList',
        Service: 'iam',
        Version: '2015-11-01'
    }),
    DescribeTags: {
        url: apiUrl({
            Action: 'DescribeTags',
            Service: 'tag',
            Version
        }),
        method: 'post'
    },
    BatchEditTags: {
        url: apiUrl({
            Action: 'BatchEditTags',
            Service: 'tag',
            Version
        }),
        method: 'post'
    },
    //获取计费方式用于试用转正
    getCharTypeEip: apiUrl({
        Action: 'DescribePriceSystem',
        Service,
        Version
    }),
    CreateEipProduct: {
        method: 'post',
        url: apiUrl({
            Action: 'CreateEipProduct',
            Service: 'bws',
            Version
        })
    },
    bandwidthList: apiUrl({
        Action: 'DescribeBws',
        Service: 'bws',
        Version
    }),
    CalculateEipProduct: {
        method: 'post',
        url: apiUrl({
            Action: 'CalculateEipProduct',
            Service: 'bws',
            Version
        })
    },
    QueryEipCount: apiUrl({
        Action: 'QueryEipCount',
        Service,
        Version
    }),
    AddressesList: {
        method: 'post',
        url: apiUrl({
            Action: 'AddressesList',
            Service,
            Version
        })
    },
    GetEipMinitorDate: apiUrl({
        Action: 'GetEipMinitorDate',
        Service,
        Version
    }),
    DescribeAddressPortfwdsOfEip: apiUrl({
        Action: 'DescribeAddressPortfwdsOfEip',
        Service,
        Version
    }),
    QueryVmListForAssociateEip: apiUrl({
        Action: 'QueryVmListForAssociateEip',
        Service,
        Version
    }),
    QueryVmLisForAssociatePortfwd: apiUrl({
        Action: 'QueryVmLisForAssociatePortfwd',
        Service,
        Version
    }),
    AssociateAddressPortfwd: apiUrl({
        Action: 'AssociateAddressPortfwd',
        Service,
        Version
    }),
    BatchDisassociateAddressPortfwd: apiUrl({
        Action: 'BatchDisassociateAddressPortfwd',
        Service,
        Version
    }),
    BatchDisassociateAddress: {
        url: apiUrl({
            Action: 'BatchDisassociateAddress',
            Service,
            Version
        }),
        method: 'post'
    },
    BatchReleaseAddress: apiUrl({
        Action: 'BatchReleaseAddress',
        Service,
        Version
    }),
    BatchCalculateProduct: {
        url: apiUrl({
            Action: 'BatchCalculateProduct',
            Service,
            Version
        }),
        method: 'post'
    },
    BatchCreateProduct: {
        url: apiUrl({
            Action: 'BatchCreateProduct',
            Service,
            Version
        }),
        method: 'post'
    },
    CalculateProduct: apiUrl({
        Action: 'CalculateProduct',
        Service,
        Version
    }),
    CreateProduct: apiUrl({
        Action: 'CreateProduct',
        Service,
        Version
    }),
    CreateProductApply: apiUrl({
        Action: 'CreateAlbProduct',
        Service,
        Version:'2016-03-04'
    }),
    AssociateAddress: apiUrl({
        Action: 'AssociateAddress',
        Service,
        Version
    }),
    BatchAssociateAddressPortfwd: apiUrl({
        Action: 'BatchAssociateAddressPortfwd',
        Service,
        Version
    }),
    // waf eip 绑定
    // 旧的接口
    BindEip: {
        url: apiUrl({
            Action: 'BindEip',
            Version: '2018-08-08',
            Service: 'waf'
        }),
        method: 'post'
    },
    // 新的接口
    BindWaf: {
        url: apiUrl({
            Action: 'BindWaf',
            Version,
            Service
        }),
        method: 'post'
    },
    QueryEPCListForAssociateEip: apiUrl({
        Action: 'QueryEPCListForAssociateEip',
        Service,
        Version
    }),
    DescribeAddresses: apiUrl({
        Action: 'DescribeAddresses',
        Service,
        Version
    }),
    DescribeAddressesOfIgw: apiUrl({
        Action: 'DescribeAddressesOfIgw',
        Service,
        Version
    }),
    DescribeAddressesDisAssociate: apiUrl({
        Action: 'DescribeAddressesDisAssociate',
        Service,
        Version
    }),
    DescribeAddressPortfwdsOfIgw: apiUrl({
        Action: 'DescribeAddressPortfwdsOfIgw',
        Service,
        Version
    }),
    DescribeAddressesForAssociatePwd: apiUrl({
        Action: 'DescribeAddressesForAssociatePwd',
        Service,
        Version
    }),
    GetLines: apiUrl({
        Action: 'GetLines',
        Service,
        Version
    }),
    DescribeIpv6PublicIpAddresses: apiUrl({
        Action: 'DescribeIpv6PublicIpAddresses',
        Service: 'vpc',
        Version
    }),
    QueryIPV6PublicIpAddressesCount: apiUrl({
        Action: 'QueryIPV6PublicIpAddressesCount',
        Service: 'vpc',
        Version,
    }),
    DescribePriceSystemOfIpv6Public: apiUrl({
        Action: 'DescribePriceSystemOfIpv6Public',
        Service: 'price',
        Version
    }),
    // IPv6计算价格
    CalculateProductOfIpv6Public: apiUrl({
        Action: 'CalculateProductOfIpv6Public',
        Service: 'vpc',
        Version
    }),

    BatchCalculateProductOfIpv6Public: {
        url: apiUrl({
            Action: 'BatchCalculateProductOfIpv6Public',
            Service: 'vpc',
            Version
        }),
        method: 'post'
    },
    // 创建IPv6商品
    CreateProductOfIpv6Public: apiUrl({
        Action: 'CreateProductOfIpv6Public',
        Service: 'vpc',
        Version
    }),
    BatchCreateProductOfIpv6Public: {
        url: apiUrl({
            Action: 'BatchCreateProductOfIpv6Public',
            Service: 'vpc',
            Version
        }),
        method: 'post'
    },
    // 批量去除公网能力
    BatchReleaseIpv6PublicIp: apiUrl({
        Action: 'BatchReleaseIpv6PublicIp',
        Service: 'vpc',
        Version
    }),
    //指定IP申请开通EIP
    AllocateAddress: {
        method: 'post',
        url: apiUrl({
            Action: 'AllocateAddress',
            Service: 'eip',
            Version
        })
    },
    DescribeKciSupportRegions: apiUrl({
        Action: 'DescribeKciSupportRegions',
        Service: 'eip',
        Version
    })
};
